export default __webpack_public_path__ + "static/media/slider3.5c6c5cd8.gif";